export const TABLE_USER = 'User'
export const TABLE_USER_COLUMN = 'UserInfo'

export const GETME = 'ART_GET_ME' // user info
export const AVATAR = 'AVATAR'
export const TOKEN = 'TOKEN'
